<template>
  <a class="inline-flex items-center justify-center ml-t20" href="#">
    <img slot="logo" src="../assets/logo.png" />
  </a>
</template>
